import React from 'react';
import {
  FDLozenge, FDTableCell,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';

const getLozengeColorFromValue = (value) => {
  switch (value) {
    case 'Messaged Member':
    case 'Sent Roadmap':
    case 'Selected Model':
      return 'info';
    case 'Confirmed Gains Budget':
    case 'Confirm as Traded':
      return 'success';
    case 'Needs Planner Input':
      return 'error';
    default:
      return 'info';
  }
};

export const ActionLozenge = ({ value }) => {
  const color = getLozengeColorFromValue(value);

  return (
    <FDTableCell>
      {value && <FDLozenge label={value} color={color} /> }
    </FDTableCell>
  );
};

ActionLozenge.propTypes = {
  value: PropTypes.string.isRequired,
};
